import type { Platform } from '@/contexts/ProtocolContext/ProtocolContext'

/**
 * Single predicate consumed by both the BottomNav Articles trigger and the
 * `/articles` route guard, so they can never disagree about who can see the
 * tab. Mirrors `mobile/react-native/lib/articlesTab.ts`'s `canAccessArticlesTab`
 * — webapp has no separate "session exists" notion, so the active account is
 * `selectedProtocol` and a Bluesky session is required.
 */
export function canAccessArticlesTab(
    selectedProtocol: Platform,
    session: unknown | null | undefined
): boolean {
    return selectedProtocol === 'bluesky' && session != null
}
